import { useState } from "react";
import { fmtDateTime } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { PageTitle } from "./AdminLayout";
import { LeadDialog, LeadPill } from "./LeadDialog";
import { SearchBox, useParticipants } from "./Participants";

export default function LeadPage() {
  const { q, setQ, items, load } = useParticipants();
  const [f, setF] = useState("ALL");
  const [sel, setSel] = useState(null);
  const rows = items.filter((p) => f === "ALL" || (p.lead_status || "NOT_VERIFIED") === f);
  return (
    <div>
      <PageTitle title="Eligibilitas Lead" desc="Hanya peserta TERVERIFIKASI yang dapat mengambil tiket jalur Lead (divalidasi server)."><SearchBox q={q} setQ={setQ} /></PageTitle>
      <Tabs value={f} onValueChange={setF} className="mb-4">
        <TabsList>
          <TabsTrigger value="ALL" data-testid="lead-filter-all">Semua</TabsTrigger>
          <TabsTrigger value="NOT_VERIFIED" data-testid="lead-filter-not-verified">Belum</TabsTrigger>
          <TabsTrigger value="VERIFIED" data-testid="lead-filter-verified">Terverifikasi</TabsTrigger>
          <TabsTrigger value="REVOKED" data-testid="lead-filter-revoked">Dicabut</TabsTrigger>
        </TabsList>
      </Tabs>
      <div className="overflow-x-auto rounded-2xl bg-white ring-1 ring-[#1A3323]/10">
        <Table data-testid="lead-table">
          <TableHeader><TableRow><TableHead>Nama</TableHead><TableHead>Status</TableHead><TableHead>Diubah</TableHead><TableHead>Catatan</TableHead><TableHead>Climb</TableHead><TableHead /></TableRow></TableHeader>
          <TableBody>
            {rows.map((p) => (
              <TableRow key={p.id}>
                <TableCell className="font-semibold">{p.full_name}</TableCell>
                <TableCell><LeadPill s={p.lead_status} /></TableCell>
                <TableCell className="text-xs">{fmtDateTime(p.lead_verified_at)}</TableCell>
                <TableCell className="max-w-xs truncate text-xs">{p.lead_notes || "-"}</TableCell>
                <TableCell className="font-mono">{p.completed}</TableCell>
                <TableCell><Button size="sm" onClick={() => setSel(p)} data-testid={`lead-page-manage-${p.id}`}>Kelola</Button></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>
      <LeadDialog p={sel} onOpenChange={(o) => !o && setSel(null)} onDone={load} />
    </div>
  );
}
